import React from "react";

export default function Image({url, alt, className}) {
  return (
    <figure className={className}>
      <img src={url} alt={alt} />
    </figure>
  )
}